/**
 * Cookie helper utilities
 */

/**
 * Get a specific cookie value by name
 * @param {string} cookieName - The name of the cookie to retrieve
 * @returns {string|null} The cookie value or null if not found
 */
export const getCookie = cookieName => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const trimmedCookie = cookie.trim();
    const equalsIndex = trimmedCookie.indexOf('=');

    if (equalsIndex === -1) continue;

    const name = trimmedCookie.substring(0, equalsIndex);
    const value = trimmedCookie.substring(equalsIndex + 1);

    if (name === cookieName) {
      return value;
    }
  }
  return null;
};

/**
 * Get BLID (Business Location ID) from PA_BLID cookie
 * @returns {string|null} The BLID value or null if not found
 */
export const getBlid = () => {
  return getCookie('PA_BLID');
};
